
import Vue from 'vue';

interface ProgressItem {
  id: number;
  label: string;
}

interface ProgressComponentData {
  progress: ProgressItem[];
  step: number;
}

/**
 * Progress Component.
 *
 * Progress with Label each step, so user know the current status.
 */
export default Vue.extend({
  name: 'ProgressBullet',
  props: {
    /**
     * Step list.<br />
     * Model of the list:
     *
     * - id: an unique identifier.
     * - label: label of the step.
     */
    progress: {
      type: Array,
      default: () => []
    },
    /**
     * Step position of the app.
     */
    step: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressStepContainer() {
      return {
        'grid-template-columns': `repeat(${this.progress.length}, calc(100% / ${this.progress.length}))`
      };
    },
    stepList() {
      // @ts-ignore
      return this.$props.progress
        .map((p: ProgressItem) => {
          // @ts-ignore
          if (this.$props.step - p.id >= 0) {
            return p.id;
          }
          return null;
        })
        .filter((p?: number) => p !== null);
    }
  },
  methods: {
    isActive(id: number) {
      // @ts-ignore
      return this.stepList.includes(id);
    },
    isLastStep(id: number) {
      // @ts-ignore
      return this.stepList.includes(id) && this.stepList.indexOf(id) !== this.stepList.length - 1;
    }
  }
});
